/** @jsx jsx */
import { css } from '@emotion/core';
import { colorsPalette, shadows } from '../../../../../styles/colors';
import { typography, fontWeights } from '../../../../../styles/typography';

export const marker = css(typography.effra16, {
  position: 'absolute',
  left: 0,
  top: 0,
});

export const markerCard = showTooltip =>
  css({
    backgroundColor: colorsPalette.white,
    borderBottomLeftRadius: 32,
    boxShadow: shadows.shadow40,
    color: colorsPalette.grey,
    display: showTooltip ? 'block' : 'none',
    left: 0,
    position: 'absolute',
    textAlign: 'center',
    top: 0,
    transform: 'translate(-50%, calc(-100% - 25px))',
    width: 232,
    zIndex: 1,
  });

export const circle = showTooltip =>
  css({
    backgroundColor: colorsPalette.white,
    border: `5.5px solid ${
      showTooltip ? colorsPalette.black : colorsPalette.red
    }`,
    borderRadius: '50%',
    cursor: 'pointer',
    display: 'block',
    height: 18,
    left: '0',
    margin: 0,
    outline: 'none',
    padding: 0,
    width: 18,

    '&:hover': {
      border: `5.5px solid ${colorsPalette.black}`,
    },
  });

export const markerTitle = showTooltip =>
  css(typography.effra14, {
    background: colorsPalette.white,
    borderRadius: 18,
    display: showTooltip ? 'none' : 'block',
    fontFamily: 'effra, sans-serif',
    fontWeight: fontWeights.regular,
    left: '50%',
    padding: '2px 8px',
    position: 'absolute',
    top: 'calc(100% + 4px)',
    transform: 'translateX(-50%)',
    whiteSpace: 'nowrap',
    width: 'auto',
    zIndex: -1,
  });

export const clusterMarker = showHover =>
  css(typography.effra16, {
    alignItems: 'center',
    backgroundColor: showHover ? colorsPalette.black : colorsPalette.red,
    borderRadius: '50%',
    color: 'white',
    display: 'flex',
    fontFamily: 'effra, sans-serif',
    fontWeight: fontWeights.medium,
    height: 40,
    justifyContent: 'center',
    width: 40,
  });
